import React from 'react'
import PropTypes from 'prop-types'

import './SlideshowProgress.scss'

import CircleProgress from './CircleProgress'
import {padStart} from 'lodash'

const SlideshowProgress = ({currentSlide, totalSlides, currentTime, currentTotalTime}) => (
  <div styleName="slideshow-progress">
    <div>
      <div styleName="circle-progress-container">
        <CircleProgress current={currentTime} total={currentTotalTime}/>
      </div>
      <div data-id="current-slide" styleName="slides-count-start">{padStart(currentSlide+1, 2, '0')}</div>
    </div>
    <div>/</div>
    <div data-id="slides-count" >{padStart(totalSlides, 2, '0')}</div>
  </div>
)
SlideshowProgress.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  currentTotalTime: PropTypes.number.isRequired
}

export default SlideshowProgress
